import React from "react";

import {
  message,
  Form,
  Row,
  Col,
  Button,
  Select,
  Icon,
  Input,
  Modal,
} from "antd";
import MiCompAPI from "../../util/api";

import img from "../../assets/img/At the office-pana 1.png";

const { Option } = Select;

class FD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SRPlans: [],
      allFieldsLoading: true,
      SelectedTemplateR: undefined,
      SREvents: [],
      selectedEvent:0,
      visible: false,
      status: false,
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    this.GetAllSRTemplate();
  }

  GetAllSRTemplate() {
    this.api.invoke("GetAllSRTemplate", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            allFieldsLoading: false,
            SRPlans: data.data.plans,
            SREvents: data.data.srevents,
          });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }

  handleSubmit = (e, data) => {
    e.preventDefault();
    this.props.form.validateFields((err, value) => {
      if (!err) {
        
        this.InsertAndUpdateSR({
          srId: 0,
          eventId:this.state.selectedEvent,
          templateId: this.state.SelectedTemplateR.fields[0].templateId,
          comments: value.comments,
          fields: this.state.SelectedTemplateR.fields.map((x) => {
            return {
              id: 0,
              templateId: x.templateId,
              fieldID: x.fieldID,
              fieldValue: x.fieldValue,
              // isCustom:x.isCustom,
            };
          }),
        });
      }
    });
  };
  InsertAndUpdateSR = (data) => {
    this.api.invoke(
      "InsertAndUpdateSR",
      "post",
      (data, success) => {
        if (success) {      
          if (data.statusCode === 200) {
            this.setState({ visible: false });
            this.props.submitHandler();
            message.destroy();
            message.success(data.statusMessage, 3);
            this.UserDefaultHandler();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        } else {
        }
      },
      data
    );
  };
  onChanges = (e) => {
    
    this.setState({
      selectedEvent:e
    });

    let templateId = this.state.SREvents.find(
      (x) => x.eventId === e
    ).templateId;

    this.api.invoke(
      "GetSRTemplateById/" + templateId,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            let dataRF = data.data;
            this.setState({
              SelectedTemplateR: dataRF,
              visible: true,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p style={{ marginLeft: "14px" }} className="mi_title">
              Add Request
            </p>
          </Col>
          <Col span={6}>
            <i
              className="fa fa-times mi_icon mi_icon_red mi_button_close"
              style={{ color: "red" }}
              onClick={this.props.closeDrawerHandler}
            ></i>
          </Col>
        </Row>

        <Form layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Select Plan </legend>
                  {getFieldDecorator("planId", {
                    rules: [
                      {
                        required: true,
                        message: (
                          <span style={{ marginTop: "-6px !important" }}>
                            {" "}
                            Please Select Plan.{" "}
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Select
                      suffixIcon={
                        <Icon
                          style={{ transform: "rotate(90deg)" }}
                          type="double-right"
                        />
                      }
                      showSearch={true}
                      className="mi_input"
                      optionFilterProp="children"
                      placeholder="Type *"
                    >
                      {this.state.SRPlans.map((tag) => (
                        <Option value={tag.planId} key={tag.planId}>
                          {tag.planName}
                        </Option>
                      ))}
                    </Select>
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Select Event </legend>{" "}
                  {getFieldDecorator("eventId", {
                    rules: [
                      {
                        required: true,
                        message: (
                          <span style={{ marginTop: "-6px !important" }}>
                            {" "}
                            Please Select an Event.{" "}
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Select
                      suffixIcon={
                        <Icon
                          style={{ transform: "rotate(90deg)" }}
                          type="double-right"
                        />
                      }
                      showSearch={true}
                      className="mi_input"
                      optionFilterProp="children"
                      placeholder="Type *"
                      onChange={this.onChanges}
                    >
                      {this.state.SREvents.map((tag) => (
                        <Option value={tag.eventId} key={tag.eventId}>
                          {tag.eventName}
                        </Option>
                      ))}
                    </Select>
                  )}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row span={24}>
          {this.state.SelectedTemplateR && this.state.SelectedTemplateR ? (
            <Modal visible={this.state.visible}>
              <div className="mi_model_popup">
                <Row span={24}>
                  <Col span={18}>
                    <p style={{ marginLeft: "14px" }} className="mi_title">
                      Add Request
                    </p>
                  </Col>
                  <Col span={6}>
                    <i
                      className="fa fa-times mi_icon mi_icon_red mi_button_close"
                      onClick={() =>
                        this.setState({
                          visible: false,
                        })
                      }
                    ></i>
                  </Col>
                </Row>
                <Form
                  onSubmit={this.handleSubmit}
                  layout="vertical"
                  hideRequiredMark
                >
                  <Row span={24}>
                    <Col md={24} sm={24}>
                      {this.state.SelectedTemplateR &&
                      this.state.SelectedTemplateR.fields &&
                      this.state.SelectedTemplateR.fields.length > 0 ? (
                        this.state.SelectedTemplateR.fields.map((x) => {
                          if (x.fieldTypeName === "textarea") {
                            return (
                              <Row span={24}>
                                <Col md={24} sm={24}>
                                  <Form.Item>
                                    <fieldset
                                      style={{ height: "auto" }}
                                      className="mi_input_pop"
                                    >
                                      <legend className="legend-font">
                                        {x.fieldLabelName}
                                      </legend>
                                      {getFieldDecorator(x.fieldLabelName, {
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "Please enter " +
                                              x.fieldLabelName,
                                          },
                                          {
                                            pattern:
                                              /^(?!\s)(?![\s\S]*\s$)[A-Z0-9]+[a-zA-Z0-9\s_,/,#,-,@,.,]*$/,
                                            message:
                                              "No whitespace at the beginning and end,First letter should be Capital",
                                          },
                                        ],
                                      })(
                                        <Input.TextArea
                                          onChange={(e) => {
                                            x.fieldValue = e.target.value;
                                          }}
                                          type="text"
                                          style={{ height: "100px" }}
                                          autoComplete="off"
                                          className="mi_input"
                                          placeholder={x.fieldPlaceHolder}
                                        />
                                      )}
                                    </fieldset>
                                  </Form.Item>
                                </Col>
                              </Row>
                            );
                          }

                          if (x.fieldTypeName === "text") {
                            return (
                              <Row span={24}>
                                <Col md={24} sm={24}>
                                  <Form.Item>
                                    <fieldset
                                      style={{ height: "auto" }}
                                      className="mi_input_pop"
                                    >
                                      <legend className="legend-font">
                                        {x.fieldLabelName}
                                      </legend>
                                      {getFieldDecorator(x.fieldLabelName, {
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "Please enter " +
                                              x.fieldLabelName,
                                          },
                                          {
                                            pattern:
                                              /^(?!\s)(?![\s\S]*\s$)[A-Z0-9]+[a-zA-Z0-9\s_,/,#,-,@,.,]*$/,
                                            message:
                                              "No whitespace at the beginning and end,First letter should be Capital",
                                          },
                                        ],
                                      })(
                                        <Input
                                          onChange={(e) => {
                                            x.fieldValue = e.target.value;
                                          }}
                                          className="mi_input"
                                          maxLength={40}
                                          type="text"
                                          autoComplete="off"
                                          placeholder={x.fieldPlaceHolder}
                                        />
                                      )}
                                    </fieldset>
                                  </Form.Item>
                                </Col>
                              </Row>
                            );
                          }
                          // if (x.fieldTypeName === "email") {
                          //   return (
                          //     <Row span={24}>
                          //       <Col md={24} sm={24}>
                          //         <Form.Item>
                          //           <fieldset
                          //             style={{ height: "auto" }}
                          //             className="mi_input_pop"
                          //           >
                          //             <legend className="legend-font">
                          //               {x.fieldLabelName}
                          //             </legend>
                          //             {getFieldDecorator(x.fieldLabelName, {
                          //               rules: [
                          //                 {
                          //                   required: true,
                          //                   message:
                          //                     "Please enter " + x.fieldLabelName,
                          //                 },
                          //                 {
                          //                   pattern:
                          //                     /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                          //                   message: "Email is invalid.",
                          //                 },

                          //                 {
                          //                   whitespace: true,
                          //                   message: "Email is invalid.",
                          //                 },
                          //               ],
                          //             })(
                          //               <Input
                          //                 onChange={(e) => {
                          //                   x.fieldValue = e.target.value;
                          //                 }}
                          //                 className="mi_input"
                          //                 maxLength={40}
                          //                 type="text"
                          //                 placeholder={x.fieldPlaceHolder}
                          //               />
                          //             )}
                          //           </fieldset>
                          //         </Form.Item>
                          //       </Col>
                          //     </Row>
                          //   );
                          // }
                          return <></>;
                        })
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                  <Row span={24}>
                    <Col md={24} sm={24}>
                      <Form.Item>
                        <fieldset
                          style={{ height: "auto" }}
                          className="mi_input_pop"
                        >
                          <legend className="legend-font">Comments</legend>
                          {getFieldDecorator("comments", {
                            rules: [
                              {
                                required: false,
                                message: "Please enter ",
                              },
                              {
                                pattern:
                                  /^(?!\s)(?![\s\S]*\s$)[A-Z0-9]+[a-zA-Z0-9\s_,/,#,-,@,.,]*$/,
                                message:
                                  "No whitespace at the beginning and end,First letter should be Capital",
                              },
                            ],
                          })(
                            <Input.TextArea
                              type="text"
                              style={{ height: "100px" }}
                              autoComplete="off"
                              className="mi_input"
                              placeholder="Enter Comments"
                            />
                          )}
                        </fieldset>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row span={24} style={{ marginTop: "30px" }}>
                    <Col span={7}></Col>
                    <Col span={5}>
                      <Button
                        className="mi_button_right submit-button"
                        onClick={() =>
                          this.setState({
                            visible: false,
                          })
                        }
                        style={{ marginRight: 8 }}
                      >
                        Cancel
                      </Button>
                    </Col>
                    <Col span={5}>
                      {!this.state.isPreview && (
                        <Button
                          htmlType="submit"
                          className="submit-button"
                          type="primary"
                        >
                          Submit
                        </Button>
                      )}
                    </Col>
                    <Col span={7}>
                      <img
                        alt="example"
                        style={{
                          height: "70px",
                          marginBottom: "-30px",
                          float: "right",
                        }}
                        src={img}
                      />
                    </Col>
                  </Row>
                </Form>
              </div>
            </Modal>
          ) : (
            <></>
          )}
        </Row>
      </div>
    );
  }
}
const AddRequestTemplate = Form.create()(FD);
export default AddRequestTemplate;
